import React from 'react'

const ScrollDown = () => {
  return (
    <div className='scroll_down'>
        <a href="#about" className='mousewrapper'>
            <span className='mouse'>
                <span className='wheel'></span>
            </span>
        </a>
    </div>
  )
}

export default ScrollDown
